// extracted by mini-css-extract-plugin
export default {"clubDescription":"CustomTextarea_clubDescription__47z9W"};